<template>
  <div id="page-wrapper">
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h3 class="text-themecolor">{{ $t('backout.title1') }}</h3>
      </div>
      <div class="col-md-7 align-self-center">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="javascript:void(0)">{{ $t('nav.home') }}</a></li>
          <li class="breadcrumb-item"><a href="javascript:void(0)">{{ $t('nav.revenue') }}</a></li>
          <li class="breadcrumb-item active">{{ $t('backout.title1') }}</li>
        </ol>
      </div>
    </div>
    <div class="container-fluid">
      <!-- /row -->
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <div class="card">
            <div class="card-header">
              <div class="pull-right">
                
              </div>
              <el-date-picker
                  v-model="dateRange"
                  type="daterange"
                  :range-separator="$t('vendor.contract.to')"
                  :start-placeholder="$t('vendor.contract.start-date')"
                  :end-placeholder="$t('vendor.contract.end-date')"
                  value-format="yyyy-MM-dd"
                  >
                </el-date-picker>
            </div>
            <div class="card-body">
              <table id="backout-report" class="table table-striped table-bordered" style="width: 1500px">
                <thead>
                  <tr>
                    <th><strong>{{ $t('dashboard.o-r.offer') }}</strong></th>
                    <th><strong>{{ $t('backout.offer-value') }}</strong></th>
                    <th><strong>{{ $t('dashboard.o-r.cashin-date') }}</strong></th>
                    <th><strong>{{ $t('dashboard.o-r.cashin') }}</strong></th>
                    <th><strong>{{ $t('backout.turn-down-date') }}</strong></th>
                    <th><strong>{{ $t('backout.backout-value') }}</strong></th>
                    <th><strong>{{ $t('backout.type') }}</strong></th>
                    <th><strong>{{ $t('backout.transfer-date') }}</strong></th>
                    <th><strong>{{ $t('backout.transfer-value') }}</strong></th>
                    <th><strong>{{ $t('backout.action') }}</strong></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="b in data.data">
                    <td><router-link :to="'/offer/' + b.offerId">{{ b.vacancy }}</router-link></td>
                    <td>{{ b.offerValue }}</td>
                    <td>{{ b.cashinDate }}</td>
                    <td>{{ b.cashin }}</td>
                    <td>{{ b.backoutDate }}</td>
                    <td>{{ b.backoutValue }}</td>

                    <td>{{ (b.transferType != null && b.transferType != '') ? getTransferType(b.transferType) : '' }}</td>
                    <td>{{ b.transferDate }}</td>
                    <td>{{ b.transferValue }}</td>
                    <td><router-link :to="'/offer/' + b.transferTo">{{ b.transferToDetail }}</router-link></td>                   
                  </tr>
                </tbody>
                <tfoot> 
                        <tr> 
                            <td>{{ $t('backout.total') }}</td> 
                            <td>&nbsp;</td> 
                            <td>&nbsp;</td> 
                            <td>&nbsp;</td> 
                            <td>&nbsp;</td> 
                            <td>{{ data.backoutSum }}</td> 
                            <td>&nbsp;</td> 
                            <td>&nbsp;</td> 
                            <td>{{ data.transferSum }}</td> 
                            <td>&nbsp;</td> 
                        </tr> 
                    </tfoot> 
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import { Loading } from 'element-ui'
import moment from 'moment'

export default {
  name: 'BackoutDetail',
  props: ['message'],
  data: function() {
  return {
    dateRange: [moment().startOf('year').format('YYYY-MM-DD'), moment().endOf('year').format('YYYY-MM-DD')],
    data: []
  }
  },
  watch: {
    dateRange: function(val) {
      this.loadData()
    }
  },
  methods: {
    loadData: function() {
      let that = this,
          startDate = this.dateRange[0],
          endDate = this.dateRange[1],
          query = '?userId=' + localStorage.getItem('token') + '&startDate=' + startDate + '&endDate=' + endDate,
          loading = Loading.service({ fullscreen: true })
    this.$http.get(this.API3_PREFIX + 'backout_list' + query).then(function (response) {
    that.data = response.data
    that.$nextTick(() => {
      loading.close()
    })
    /*that.$message({
          message: that.$t('backout.auth'),
          type: 'error'
        })*/
      }).catch(function (error) {
    console.log(error)
    that.$nextTick(() => {
      loading.close()
    })
      })
    }
  },
  created: function() {
    this.loadData()
  }
}
</script>